import _default from './Image';
export { _default as default };